module.exports = __webpack_public_path__ + "static/media/logo_medium.89c4a7f5.png";